// extracted by mini-css-extract-plugin
export default {"PaymentHistory_list_title":"paymentHistory_PaymentHistory_list_title__3dOVB","PaymentHistory_title-text":"paymentHistory_PaymentHistory_title-text__UjQ05"};